import PushDepositEvent from "components/PusherEvent";
import AllGameModal from "components/modal/all_game_modal";
import AlertWithDeposit from "components/modal/deposit_modal";
import AlertWithDepositV2 from "components/modal/deposit_modal_v2";
import LineOASelectorModal from "components/modal/line_oa_selector_modal";
import MenuModal from "components/modal/menu_modal";
import MessageModal from "components/modal/message_modal";
import PopUpModal from "components/modal/pop_up_modal";
import RejectModal from "components/modal/reject_modal";
import SuccessModal from "components/modal/success_modal";
import AlertWithWithDraw from "components/modal/withdraw_modal";
import WithdrawModalV2 from "components/modal/withdraw_modal_v2";
import NavBar from "components/view/nav_bar";
import NotiVenderChat from "components/view/noti_venderchat";
import NotificationMessage from "components/view/notification_message";
import OptimizeImage from "components/view/optimize_image";
import { checkLogin } from "lib/check_login";
import global, { THEME_COLOR } from "lib/config/global";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import get_all_content_by_prefix from "lib/worker/api/get_all_content_by_prefix";
import get_line_oa_settings_by_prefix, {
  LineOASettingResponse,
} from "lib/worker/api/get_line_oa_settings_by_prefix";
import get_popup_list_list_on_website, {
  GetPopupSettingByVenderIDSQL,
} from "lib/worker/api/get_popup_list_list_on_website";
import get_vender_domain_infomation from "lib/worker/api/get_vender_domain_infomation";
import header_config from "lib/worker/api/header_config";
import theme_color from "lib/worker/api/theme_color";
import { GetServerSideProps } from "next";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { connect } from "react-redux";
import getinfo from "../../lib/worker/api/getinfo";
import NavNavigation from "../view/nav_navigation";

export interface LayoutMasterProps {
  content_setting: ContentSetting;
  state?: AppReducerStateProps;
  information: CheckWithPrefixResponse;
}

export interface ContentSetting {
  title: string;
  description?: string | undefined;
}

const LINE_OA_SELECTOR_TOKEN = "__LINE_OA_SELECTOR__";

function getVisibleLineOASettings(
  settings: LineOASettingResponse[],
): LineOASettingResponse[] {
  const visibleSettings = (settings ?? []).filter(
    (setting) =>
      (setting.is_visible ?? false) && (setting.url ?? "").trim() !== "",
  );
  return visibleSettings;
}

function resolveLineSupportState(
  settings: LineOASettingResponse[],
  fallbackLineLink: string | null | undefined,
): {
  lineLink: string | null;
  selectorSettings: LineOASettingResponse[];
} {
  const visibleSettings = getVisibleLineOASettings(settings);

  if (visibleSettings.length > 1) {
    return {
      lineLink: LINE_OA_SELECTOR_TOKEN,
      selectorSettings: visibleSettings,
    };
  }

  if (visibleSettings.length === 1) {
    return {
      lineLink: (visibleSettings[0].url ?? "").trim() || null,
      selectorSettings: [],
    };
  }

  const fallback = (fallbackLineLink ?? "").trim();
  return {
    lineLink: fallback === "" ? null : fallback,
    selectorSettings: [],
  };
}

const LayoutMaster: React.FC<LayoutMasterProps> = ({ children, ...rest }) => {
  const { title, description } = rest.content_setting;
  const { information } = rest;
  const router = useRouter();
  const { prefix } = global().gobalVariable;
  const { themeColor } = rest.state!.member;
  const [lineid, setlineid] = useState<string | null | undefined>(
    information.lineidchat ?? null,
  );
  const [lineOASelectorSettings, setLineOASelectorSettings] = useState<
    LineOASettingResponse[]
  >([]);
  const [isLineOASelectorOpen, setIsLineOASelectorOpen] =
    useState<boolean>(false);
  const [popups, setpopups] = useState<GetPopupSettingByVenderIDSQL[]>([]);
  const [showModalPopup, setShowModalPopup] = useState<boolean>(false);
  const [cookies, setCookie] = useCookies(["popup_list_list_on_website"]);

  useEffect(() => {
    get_popup_list_list_on_website({
      prefix: rest.information.prefix,
    })
      .then((json) => {
        setpopups(json);
        return json;
      })
      .then((value) => {
        if (value.length > 0) {
          if (!cookies.popup_list_list_on_website) {
            setShowModalPopup(true);
          }
        }
      });
  }, []);

  useEffect(() => {
    if (checkLogin()) {
      getinfo();
    }

    async function loadinfo() {
      try {
        await theme_color({
          prefix: prefix ?? "snb",
          themeColor: localStorage.getItem(THEME_COLOR),
        });
        const infomation = await get_vender_domain_infomation({
          domain: information.domain,
        });
        await theme_color({
          prefix: infomation.Prefix,
          themeColor: localStorage.getItem(THEME_COLOR),
        });

        const infomations = CheckWithPrefix({ host: information.domain });
        const fallbackLineLink = infomations.lineidchat;

        let lineOASettings: LineOASettingResponse[] = [];
        try {
          lineOASettings = await get_line_oa_settings_by_prefix({
            prefix: information.prefix,
          });
        } catch (_error) {}

        const lineSupportState = resolveLineSupportState(
          lineOASettings,
          fallbackLineLink,
        );
        setlineid(lineSupportState.lineLink);
        setLineOASelectorSettings(lineSupportState.selectorSettings);
      } catch (error) {}
    }

    loadinfo();
  }, []);

  const lineSupportHref =
    lineid === LINE_OA_SELECTOR_TOKEN ? "#" : (lineid ?? "#");

  const handleLineSupportClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    if (lineid !== LINE_OA_SELECTOR_TOKEN) {
      return;
    }

    event.preventDefault();
    setIsLineOASelectorOpen(true);
  };

  const closeLineOASelectorModal = () => {
    setIsLineOASelectorOpen(false);
  };

  const renderLineOASelectorModal = () => {
    return (
      <LineOASelectorModal
        isOpen={isLineOASelectorOpen}
        settings={lineOASelectorSettings}
        onClose={closeLineOASelectorModal}
      />
    );
  };

  const closePopup = () => {
    let housrexpires = new Date();
    housrexpires.setTime(housrexpires.getTime() + 60 * 60 * 1000);
    setCookie("popup_list_list_on_website", true, { expires: housrexpires });
    setShowModalPopup(!showModalPopup);
  };

  const candisplay = (): any => {
    if (router.pathname.includes("contact")) {
      return children;
    } else {
      return information.disable_web_site ? (
        <div
          style={{
            minHeight: "80vh",
            padding: "4rem 0",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1>ทางเราขอปิดบริการชั่วคราว</h1>
          <h4>ขออภัยเป็นอย่างยิ่ง แล้วเราจะกลับมาพบกันใหม่</h4>
          <p>
            สามารถต่อเราได้ผ่านทางนี้{" "}
            <Link href={`/contact/${information.prefix}`}>
              <a>ติดต่อ</a>
            </Link>
          </p>
        </div>
      ) : (
        children
      );
    }
  };

  return (
    <div className="main-content">
      <Head>
        <title>{title}</title>
        <meta property="og:title" content={`${title}`}></meta>
        <meta name="title" content={`${title}`}></meta>
        <meta
          name="description"
          property="description"
          content={description ?? ""}
        ></meta>
        <meta
          name="viewport"
          content="width=device-width, user-scalable=no"
        ></meta>
        <style>{themeColor}</style>
      </Head>
      {router.pathname.includes("contact") == false && (
        <div>
          {information.isChatWebsite && (
            <>
              <NotiVenderChat></NotiVenderChat>
              <Link href={`/contact/${information.prefix}`}>
                <a className="floating-btn-2">
                  <OptimizeImage
                    className="margin-right-20"
                    src="icon-chat-4.png"
                    alt="แชท 24 ชั่วโมง"
                  ></OptimizeImage>
                </a>
              </Link>
            </>
          )}
          {lineid != null ? (
            <Link href={lineSupportHref}>
              <a className="floating-btn" onClick={handleLineSupportClick}>
                <OptimizeImage
                  className="margin-right-20"
                  src="live-chat-icon2.png"
                  alt="LINE SUPPORT"
                ></OptimizeImage>
              </a>
            </Link>
          ) : (
            <>
              <NotificationMessage></NotificationMessage>
              <Link href={`/contact/${prefix}`}>
                <a className="floating-btn">
                  <OptimizeImage
                    className="margin-right-20"
                    src="icon-chat-4.png"
                    alt="แชท 24 ชั่วโมง"
                  ></OptimizeImage>
                </a>
              </Link>
            </>
          )}
        </div>
      )}
      <NavBar infomation={information}></NavBar>
      <PushDepositEvent></PushDepositEvent>
      <RejectModal></RejectModal>
      <AlertWithDeposit></AlertWithDeposit>
      <AlertWithDepositV2 infomation={information}></AlertWithDepositV2>
      <AlertWithWithDraw></AlertWithWithDraw>
      <MessageModal information={information}></MessageModal>
      <AllGameModal></AllGameModal>
      <SuccessModal></SuccessModal>
      <MenuModal information={information}></MenuModal>
      <NavNavigation infomation={information}></NavNavigation>
      <WithdrawModalV2 />
      {popups.map((el, i) => {
        if (el.Disable === true) {
          return <></>;
        }
        return (
          <>
            <PopUpModal
              key={i}
              popups={popups}
              infomation={information}
              show={showModalPopup}
              handleClose={closePopup}
            ></PopUpModal>
          </>
        );
      })}
      <main className="children-top">{candisplay()}</main>
      {renderLineOASelectorModal()}
    </div>
  );
};

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });
  try {
    const [content] = await Promise.all([
      get_all_content_by_prefix({
        prefix: infomation.prefix,
      }),

      header_config({
        prefix: infomation.prefix,
      }),
    ]);

    return {
      props: {
        infomation: infomation,
        content: content,
      },
    };
  } catch (error) {
    return {
      props: {
        infomation: infomation,
      },
    };
  }
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(
  LayoutMaster,
) as React.FC<LayoutMasterProps>;
